<template>
  <div>
    <Header theme="white" @setScroll="setScroll"></Header>
    <div class="banner">
      <div class="word">
        <div class="wordtitle">
          解决方案
        </div>
        <div class="smalltitle">
          / The Solution
        </div>
      </div>
    </div>
    <div class="newList">
      <div id="news">
        <div>
          <div class="list" v-for="(item, index) in PageList" :key="index" @click="toDetails(item.id)">
            <img class="img" :src="baseUrl + item.subImage">
            <div class="topTitle">
              {{item.topTitle}}
            </div>
            <div class="topContent">
              {{item.topContent}}
            </div>
            <div class="bglist">
              <div>
                <div>
                  <div class="fangan">
                    查看方案详情</div>
                  <img src="../../assets/images/JT2@2x.png" width="18px" height="9px">
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <Paging @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" :currentPage="pageNum"
        :loading="loading" :pageSize="pageSize" :total="total"></Paging>
    </div>

    <Footer />
  </div>
</template>

<script>
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  import Paging from "@/components/common/commonTable";
  import {
    serverUrl
  } from '@/utils/server.js'
  import {
    getJJFAData
  } from '@/api/api'
  export default {
    data() {
      return {
        scroll: 'home',
        PageList: [],
        loading: false,
        baseUrl: serverUrl.baseURL,
        pageNum: 0,
        pageSize: 9,
        loading: false,
        total: 0,
      }
    },
    components: {
      Header,
      Footer,
      Paging
    },
    mounted() {
      this.setJJFAData()
    },
    methods: {
      toDetails(val, index) {
        this.$router.push({
          path: '/DetailsPage',
          query: {
            data: val
          },
        })
      },
      setJJFAData() {
        var params = {
          page: this.pageNum >= 1 ? this.pageNum - 1 : this.pageNum,
          size: this.pageSize
        }
        getJJFAData(params).then(res => {
          this.PageList = res.data.content
          this.total = Number(res.data.totalElements)
        })
      },
      //当前页变更
      handleCurrentChange(num) {
        // if (num > 1) {
        //   this.pageNum = num - 1;
        // } else {
        //   this.pageNum = num + 1;
        // }
        console.log(num)
        this.pageNum = num
        console.log(this.pageNum)
        this.setJJFAData();
      },
      //当前页查询数据条数变更
      handleSizeChange(num) {
        this.pageSize = num;
        this.pageNum = 1;
        this.currentPage = 1;
        this.setJJFAData();
      },
    }
  }
</script>

<style scoped>
  .banner {
    width: 100%;
    height: 400px;
    background: url(../../assets/images/jjfa@2x.png) top center no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
  }

  .sidebar {
    width: 1337px;
    margin: 0 auto;
  }

  .newList {
    width: 1373px;
    margin: 40px auto 0;
  }

  .word {
    width: 1337px;
    margin: 100px auto 0;
  }

  .contain {
    overflow-x: hidden;
    font-size: 16px;
    height: 100vh;
    font-family: PingFang-SC-Medium, PingFang-SC !important;
  }

  ::-webkit-scrollbar {
    display: none !important;
    /* Chrome */
  }

  /deep/ .sidebarLeft .el-tabs__active-bar {
    position: absolute;
    top: 0px;
    right: 0;
    height: 20px;
    background: #1E65F2;
    border-radius: 3px;
    z-index: 1;
  }

  .line {
    display: -webkit-box;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  #news {
    height: 102%;
    overflow-y: auto;
  }

  .list {
    position: relative;
  }

  .bglist {
    position: absolute;
    width: 100%;
    height: 320px;
    line-height: 320px;
    top: 0;
    left: 0;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.3);

    display: none;

  }

  .bglist>div {
    width: 100%;
    height: 320px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .list:hover .bglist {
    display: block;
  }

  #news>div {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap
  }

  .wordtitle {
    font-size: 42px;
    font-family: Source Han Sans CN;
    color: #FFFFFF;
    line-height: 46px;
  }

  .smalltitle {
    font-size: 16px;
    font-family: Adobe Heiti Std;
    color: #FFFFFF;
    line-height: 46px;
  }

  .list {
    box-shadow: 0px 2px 10px 0px rgba(220, 221, 236, 0.5);
    border-radius: 8px;
    width: 396px;
    height: 320px;
    margin: 0 30px 30px;
    cursor: pointer;
  }

  .img {
    width: 395px;
    height: 200px;
    border-radius: 8px;
  }

  .topTitle {
    padding: 6px 12px;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #121E30;
  }

  .topContent {
    padding: 6px 12px;
    box-sizing: border-box;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #516381;
    line-height: 21px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 50px;
  }

  .fangan {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #FFFFFF;
    display: inline-block;
  }

  .bglist>div>div {
    width: 231px;
    height: 58px;
    border: 2px solid #FFFFFF;
    border-radius: 28px;
    line-height: 58px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/solution/SolutionList.vue